import { render, staticRenderFns } from "./treasury.vue?vue&type=template&id=d896168c&"
import script from "./treasury.vue?vue&type=script&lang=js&"
export * from "./treasury.vue?vue&type=script&lang=js&"
import style0 from "./treasury.vue?vue&type=style&index=0&id=d896168c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports